/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type HoleScoringQueryVariables = {|
  eventId: string,
  roundNum?: ?number,
|};
export type HoleScoringQueryResponse = {|
  +pgaHoleScoring: ?$ReadOnlyArray<?{|
    +course: ?{|
      +name: string
    |},
    +holeScores: ?$ReadOnlyArray<?{|
      +hole: {|
        +holeNum: number,
        +par: number,
      |},
      +toParAverage: any,
      +eagles: number,
      +birdies: number,
      +pars: number,
      +bogeys: number,
      +doubleBogeys: number,
      +tripleBogeysOrWorse: number,
    |}>,
  |}>
|};
export type HoleScoringQuery = {|
  variables: HoleScoringQueryVariables,
  response: HoleScoringQueryResponse,
|};
*/


/*
query HoleScoringQuery(
  $eventId: ID!
  $roundNum: Int
) {
  pgaHoleScoring(eventId: $eventId, roundNum: $roundNum) {
    course {
      name
      id
    }
    holeScores {
      hole {
        holeNum
        par
        id
      }
      toParAverage
      eagles
      birdies
      pars
      bogeys
      doubleBogeys
      tripleBogeysOrWorse
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "eventId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "roundNum"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "eventId",
    "variableName": "eventId"
  },
  {
    "kind": "Variable",
    "name": "roundNum",
    "variableName": "roundNum"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "holeNum",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "par",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "toParAverage",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eagles",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "birdies",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pars",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bogeys",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "doubleBogeys",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tripleBogeysOrWorse",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HoleScoringQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PGATourHoleScoringForCourseType",
        "kind": "LinkedField",
        "name": "pgaHoleScoring",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourCourseType",
            "kind": "LinkedField",
            "name": "course",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourHoleScoringType",
            "kind": "LinkedField",
            "name": "holeScores",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PGATourEventHoleForRoundType",
                "kind": "LinkedField",
                "name": "hole",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HoleScoringQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PGATourHoleScoringForCourseType",
        "kind": "LinkedField",
        "name": "pgaHoleScoring",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourCourseType",
            "kind": "LinkedField",
            "name": "course",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v12/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourHoleScoringType",
            "kind": "LinkedField",
            "name": "holeScores",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PGATourEventHoleForRoundType",
                "kind": "LinkedField",
                "name": "hole",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c3e09159c81e17674eae1130c95f85b4",
    "id": null,
    "metadata": {},
    "name": "HoleScoringQuery",
    "operationKind": "query",
    "text": "query HoleScoringQuery(\n  $eventId: ID!\n  $roundNum: Int\n) {\n  pgaHoleScoring(eventId: $eventId, roundNum: $roundNum) {\n    course {\n      name\n      id\n    }\n    holeScores {\n      hole {\n        holeNum\n        par\n        id\n      }\n      toParAverage\n      eagles\n      birdies\n      pars\n      bogeys\n      doubleBogeys\n      tripleBogeysOrWorse\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c3dab63ab6bb497491d717dc651fba4a';

module.exports = node;
